import { hasOwn } from '@utils/is'

let resizeKey = 0
const resizeEvent = {}

const directive = {
  // 当被绑定的元素插入到 DOM 中时……
  inserted(el, binding) {
    resizeKey += 1
    el.setAttribute('resizeKey', resizeKey)
    if (typeof binding.value === 'function') resizeEvent[resizeKey] = binding.value
  },
  unbind(el) {
    // 组件销毁时移除事件
    const key = el.getAttribute('resizeKey')
    delete resizeEvent[key]
  },
}

window.addEventListener('resize', () => {
  Object.keys(resizeEvent).forEach((key) => {
    if (hasOwn(resizeEvent, key)) {
      const fn = resizeEvent[key]
      if (typeof fn === 'function') fn()
    }
  })
})

function install(Vue) {
  Vue.directive('resize', directive)
}
export default install
